export default __webpack_public_path__ + "static/media/lifLogo.72197548.svg";